<template>
  <div class="m-dropdown">
    <button
      type="button"
      :id="id"
      class="a-btn a-btn--primary m-dropdown__toggle"
      :class="{ 'is-active': isOpen }"
      @click="toggle"
      @keydown.esc.prevent="close"
      :aria-expanded="isOpen ? 'true' : 'false'"
    >
      <span class="a-btn__label" v-text="title"></span>
      <svg class="a-btn__icon" aria-hidden="true">
        <use :xlink:href="$root.spritePath + '#btn-arrow-down'" />
      </svg>
    </button>

    <transition>
      <div
        ref="content"
        v-show="isOpen"
        class="m-dropdown__content"
        :class="[side ? 'is-' + side : null, align ? 'is-' + align : null]"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      id: {
        type: String,
        default: null,
      },
      url: {
        type: String,
        default: null,
      },
      align: {
        type: String,
        default: null,
      },
    },

    data: () => ({
      isOpen: false,
      side: null,
      contentBoundingClientRect: null,
    }),

    mounted() {
      document.addEventListener("click", this.handleEventOutside);
      document.addEventListener("focusin", this.handleEventOutside);
    },

    unmounted() {
      document.removeEventListener("click", this.handleEventOutside);
      document.removeEventListener("focusin", this.handleEventOutside);
    },

    methods: {
      open() {
        this.isOpen = true;

        this.$nextTick(() => {
          this.contentBoundingClientRect = this.$refs.content.getBoundingClientRect();

          if (!this.align) {
            this.setSide();
            window.addEventListener("resize", this.setSide, { passive: true });
          }
        });
      },

      close() {
        this.isOpen = false;
        if (!this.align) {
          window.removeEventListener("resize", this.setSide);
          this.side = "left";
        }
      },

      toggle() {
        this.isOpen ? this.close() : this.open();
      },

      handleEventOutside(e) {
        if (!this.$el.contains(e.target)) {
          this.close();
        }
      },

      setSide() {
        let isEntirelyVisible = (this.contentBoundingClientRect.left + this.contentBoundingClientRect.width <= document.body.offsetWidth);
        this.side = isEntirelyVisible ? "left" : "right";
      },
    },
  }
</script>
